import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { NavBar } from "@/components/NavBar";
import { SiteFooter } from "@/components/SiteFooter";
import { api } from "@/lib/api";
import { ScrollText } from "lucide-react";

export default function TermsPage() {
  const [terms, setTerms] = useState(null);

  useEffect(() => {
    api.get("/terms").then(({ data }) => setTerms(data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <NavBar />
      <main className="flex-1 mx-auto w-full max-w-3xl px-4 sm:px-6 lg:px-8 py-12 space-y-8">
        <div className="space-y-4">
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/15 border border-primary/30">
            <ScrollText className="h-5 w-5 text-primary" />
          </span>
          <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tight" data-testid="terms-title">
            {terms?.title || "Terms of Service & User Agreement"}
          </h1>
          {terms && (
            <p className="text-xs text-muted-foreground font-mono">Version {terms.version}</p>
          )}
          {terms && (
            <p className="text-sm text-muted-foreground leading-relaxed border-l-2 border-primary/40 pl-4">
              {terms.summary}
            </p>
          )}
          <p className="text-sm text-muted-foreground">
            The full Terms of Service &amp; User Agreement, together with every policy you agree to at
            registration, is published in{" "}
            <Link to="/legal" className="text-primary hover:underline" data-testid="terms-all-policies-link">
              Policies, Agreements &amp; Disclosures
            </Link>
            . Read the complete{" "}
            <Link to="/legal/terms-of-service" className="text-primary hover:underline" data-testid="terms-full-tos-link">
              Terms of Service &amp; User Agreement
            </Link>
            .
          </p>
        </div>

        <div className="space-y-5" data-testid="terms-sections">
          {(terms?.sections || []).map((section) => (
            <section key={section.title} className="rounded-xl border border-border bg-card p-6 space-y-2">
              <h2 className="font-display text-lg font-semibold">{section.title}</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">{section.body}</p>
            </section>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
